<template>
  <b-form-group
    label-cols-lg="2"
    content-cols-lg="10"
    v-bind:label="labelText">
    <b-spinner v-if="isLoading" label="Spinning" small></b-spinner>
    <b-form-select v-else
      v-model="selectedDropdownItem"
      v-on:change="selectedDropdownItemChanged"
      v-bind:disabled="isDisabled"
      v-bind:required="preventSelectDefaultItem">
      <b-form-select-option v-if="preventSelectDefaultItem" v-bind:value="null" disabled>
        Please select a {{labelText}}:
      </b-form-select-option>
      <b-form-select-option v-else v-bind:value="null">
        All
      </b-form-select-option>
      <b-form-select-option v-for="dropdownItem in dropdownItems"
        v-bind:key="dropdownItem.id"
        v-bind:value="dropdownItem.id">
        {{dropdownItem.name}}
      </b-form-select-option>
    </b-form-select>
  </b-form-group>
</template>

<script>
export default {
  name: 'AdminDropdown',
  props: {
    for: {
      type: String,
      validator(value) {
        return ['items', 'lettercases', 'organisations', 'sections', 'tasktypes', 'wordcategories', 'worksheets'].indexOf(value.toLowerCase()) !== -1;
      },
    },
    preventSelectDefaultItem: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (!this.dropdownItems?.some((s) => s.id === this.selectedDropdownItem)) {
      this.selectedDropdownItem = null;
    }
  },
  computed: {
    labelText() {
      switch (this.for.toLowerCase()) {
        case 'items':
          return 'Item';
        case 'lettercases':
          return 'Letter Case';
        case 'organisations':
          return 'Organisation';
        case 'sections':
          return 'Section';
        case 'tasktypes':
          return 'Task Type';
        case 'wordcategories':
          return 'Word Category';
        default:
          return '';
      }
    },
    dropdownItems() {
      switch (this.for.toLowerCase()) {
        case 'items':
          return this.$store.state.items.items;
        case 'lettercases':
          return this.$store.state.cases.cases;
        case 'organisations':
          return this.$store.state.organisations.organisations;
        case 'sections':
          return this.$store.state.sections.sections;
        case 'tasktypes':
          return this.$store.state.taskTypes.taskTypes;
        case 'wordcategories':
          return this.$store.state.wordCategories.wordCategories;
        default:
          return null;
      }
    },
    selectedDropdownItem: {
      get() {
        switch (this.for.toLowerCase()) {
          case 'items':
            return this.$store.state.items.selectedItemId;
          case 'lettercases':
            return this.$store.state.cases.selectedCaseId;
          case 'organisations':
            return this.$store.state.organisations.selectedOrganisationId;
          case 'sections':
            return this.$store.state.sections.selectedSectionId;
          case 'tasktypes':
            return this.$store.state.taskTypes.selectedTaskTypeId;
          case 'wordcategories':
            return this.$store.state.wordCategories.selectedWordCategoryId;
          default:
            return null;
        }
      },
      set(newValue) {
        switch (this.for.toLowerCase()) {
          case 'items':
            this.$store.dispatch('items/changeSelectedItem', newValue);
            break;
          case 'lettercases':
            this.$store.dispatch('cases/changeSelectedCase', newValue);
            break;
          case 'organisations':
            this.$store.dispatch('organisations/changeSelectedOrganisation', newValue);
            break;
          case 'sections':
            this.$store.dispatch('sections/changeSelectedSection', newValue);
            break;
          case 'tasktypes':
            this.$store.dispatch('taskTypes/changeSelectedTaskType', newValue);
            break;
          case 'wordcategories':
            this.$store.dispatch('wordCategories/changeSelectedWordCategory', newValue);
            break;
          default:
            break;
        }
      },
    },
    isLoading() {
      switch (this.for.toLowerCase()) {
        case 'items':
          return this.$store.state.sections.isLoading
          || this.$store.state.wordCategories.isLoading
          || this.$store.state.items.isLoading;
        case 'lettercases':
          return this.$store.state.sections.isLoading
          || this.$store.state.cases.isLoading;
        case 'organisations':
          return this.$store.state.organisations.isLoading;
        case 'sections':
          return this.$store.state.sections.isLoading;
        case 'tasktypes':
          return this.$store.state.sections.isLoading
          || this.$store.state.taskTypes.isLoading;
        case 'wordcategories':
          return this.$store.state.sections.isLoading
          || this.$store.state.wordCategories.isLoading;
        default:
          return false;
      }
    },
    isDisabled() {
      switch (this.for.toLowerCase()) {
        case 'items':
          return this.$store.state.sections.selectedSectionId === null
          || this.$store.state.wordCategories.selectedWordCategoryId === null;
        case 'lettercases':
          return this.$store.state.sections.selectedSectionId === null;
        case 'organisations':
          return false;
        case 'sections':
          return false;
        case 'tasktypes':
          return this.$store.state.sections.selectedSectionId === null;
        case 'wordcategories':
          return this.$store.state.sections.selectedSectionId === null;
        default:
          return false;
      }
    },
  },
  methods: {
    selectedDropdownItemChanged() {
      switch (this.for.toLowerCase()) {
        case 'items':
          break;
        case 'lettercases':
          break;
        case 'organisations':
          break;
        case 'sections':
          this.$store.dispatch('wordCategories/changeSelectedWordCategory', null);
          this.$store.dispatch('items/changeSelectedItem', null);
          this.$store.dispatch('taskTypes/changeSelectedTaskType', null);
          this.$store.dispatch('cases/changeSelectedCase', null);
          break;
        case 'tasktypes':
          break;
        case 'wordcategories':
          this.$store.dispatch('items/changeSelectedItem', null);
          break;
        default:
          break;
      }

      this.$emit('dropdownItemChanged');
    },
  },
};
</script>
